//Generation of pdf using html2pdf.js library

import html2pdf from 'html2pdf.js'

export const createPdf = (fileName, elementId, callback) => {
  var element = document.getElementById(elementId)
  var opt = {
    // margin: 10,
    filename: fileName + '.pdf',
    html2canvas: { scale: 1.2 },
    image: { type: 'jpeg', quality: 0.95 },
    pagebreak: { mode: ['avoid-all', 'css', 'legacy'] },
    jsPDF: { unit: 'mm', orientation: 'portrait' },
    pdfCallback: () => {},
  }
  html2pdf()
    .from(element)
    .set(opt)
    .toPdf()
    .get('pdf')
    .then(function (pdf) {
      var totalPages = pdf.internal.getNumberOfPages()

      for (let i = 1; i <= totalPages; i++) {
        pdf.setPage(i)
        pdf.setFontSize(10)
        pdf.setTextColor(150)
        pdf.text(
          'Page ' + i + ' of ' + totalPages,
          pdf.internal.pageSize.getWidth() - 30,
          pdf.internal.pageSize.getHeight() - 4
        )
      }
    })
    .save()
    .then(() => callback())

  // New Promise-based usage:
  // html2pdf().from(element).set(opt).save()
}

export const createPdfBase64 = (fileName, elementId, callback) => {
  let pdfInBase64
  var element = document.getElementById(elementId)
  var opt = {
    // margin: 10,
    filename: fileName + '.pdf',
    html2canvas: { scale: 1.2 },
    image: { type: 'jpeg', quality: 0.95 },
    pagebreak: { mode: ['avoid-all', 'css', 'legacy'] },
    jsPDF: { unit: 'mm', orientation: 'portrait' },
    pdfCallback: () => {},
  }
  html2pdf()
    .from(element)
    .set(opt)
    .toPdf()
    .get('pdf')
    .then(function (pdf) {
      var totalPages = pdf.internal.getNumberOfPages()

      for (let i = 1; i <= totalPages; i++) {
        pdf.setPage(i)
        pdf.setFontSize(10)
        pdf.setTextColor(150)
        pdf.text(
          'Page ' + i + ' of ' + totalPages,
          pdf.internal.pageSize.getWidth() - 30,
          pdf.internal.pageSize.getHeight() - 4
        )
      }
    })
    .outputPdf()
    .then((pdf) => {
      callback(btoa(pdf))
      return btoa(pdf)
    })
  // .save()
  // added this to activate dispatch on finish

  // New Promise-based usage:
  // html2pdf().from(element).set(opt).save()
  return pdfInBase64
}

export const getCurrentResolutionBreakPoint = (isDownloadingPdf) => {
  const currentResolution = isDownloadingPdf ? 100 : 1024
  return currentResolution
}

export const remainingLeaseTime = (leaseEndDate) => {
  let today = new Date()
  let endDate = new Date(leaseEndDate)
  if (today > endDate) return 'Expired'

  let months = (endDate.getFullYear() - today.getFullYear()) * 12
  months += endDate.getMonth()
  months -= today.getMonth()

  if (months === 0) return 'Less than 1 month'

  if (months === 1) {
    if (today.getDate() > endDate.getDate()) return 'Less than 1 month'
    else return '1 month'
  }

  return months + ' months'
}
